<template>
    <div id="content" class="packageContent">
        <div class="packageNum">共{{microNum}}份资源</div>
        <Row type="flex" v-if="pageTotal == 0" style="text-align: center;">
          <Col span="24"><img class="emptyImg" src="/static/images/empty.png" alt=""></Col>
          <Col span="24" style="margin-top:20px;">暂时没有相关内容～</Col>
        </Row>
        <Row type="flex" v-else justify="start" class="code-row-bg" v-for="(item,index) in packageList" :key="index" style="margin-bottom:15px;">
          <div class="packageCar" v-for="(n,m) in item" :key="m" :title="n.name">
              <div class="pacageTop" @click="toPackageDetail(n.id)">
                  <div class="packageTL" :ref="'ImgBoxWidth'+ m" :style="{'height':documentHeight,'line-height':documentHeight}">
                      <img :src="imgurl + n.imgPath" alt="">
                  </div>
                  <div class="packageTR">
                      <div class="packageTitle" :title="n.name">{{ n.name.split("（")[0]}}</div>
                      <div class="packageVersion packageCom">版本：{{n.versionName.length> 3 ? n.versionName.slice(0,3)+'...':n.versionName}}</div>
                  </div>
              </div>
              <!-- <div class="packageBottom">更新时间：{{n.updateTime}}</div> -->
          </div>
        </Row>

        <div class="page" v-if="pageTotal >15">
             <Page :total="pageTotal" :page-size="15" @on-change="changePage"/>
        </div>
    </div>
</template>
<script>
 import api from '../../utils/api.js';
 import bus from '../../assets/eventBus/enentBus.js';
export default {
    name:'PackageList',
    data(){
        return{
            urlHttp:'/testIp',
            packageList:null,                                         //微课列表  array
            imgurl:'https://qcban.aixuetang.com/res',              //微课图片地址  线上域名
            microNum:null,                                          // 微课数量
            pageTotal:null,                                         //总页数
            gradeId:null,                                           //年级id  通过筛选按钮传过来
            versionId:null,                                         //版本id  通过筛选按钮传过来
            subjectId:null,                                         //学科id  通过筛选按钮传过来
            termId:null,                                            //册别id  通过筛选按钮传过来
            type:null,                                              //类型id  通过筛选按钮传过来
            name:null,                                              //名字查找  通过筛选按钮传过来
            startTime:null,											                    //开始时间
            endTime:null,											                      //结束时间
            documentHeight:'',
            websiteId:''
        }
    },
    mounted(){
        this.websiteId = localStorage.getItem("websiteId")

      const that = this;
       this.getLessonPackageData(1,that.gradeId,that.subjectId,that.termId,that.versionId,that.type,that.name,that.startTime,that.endTime);

	   bus.$on('choseTime',function(msg){
	       that.startTime = msg[0]==''? null:msg[0];
         that.endTime = msg[1]==''? null:msg[1];
	       that.getLessonPackageData(1,that.gradeId,that.subjectId,that.termId,that.versionId,that.type,that.name,that.startTime,that.endTime);
	   })
       bus.$on('packageGradeId',function(msg){
           that.gradeId = msg;
           that.getLessonPackageData(1,that.gradeId,that.subjectId,that.termId,that.versionId,that.type,that.name,that.startTime,that.endTime);
       })
       bus.$on('packageSubjectId',function(msg){
           that.subjectId = msg;
           that.getLessonPackageData(1,that.gradeId,that.subjectId,that.termId,that.versionId,that.type,that.name,that.startTime,that.endTime);
       })
       bus.$on('packageVersionId',function(msg){
           that.versionId = msg;
           that.getLessonPackageData(1,that.gradeId,that.subjectId,that.termId,that.versionId,that.type,that.name,that.startTime,that.endTime);
       })
       bus.$on('packageVolumeId',function(msg){
           that.termId = msg;
           that.getLessonPackageData(1,that.gradeId,that.subjectId,that.termId,that.versionId,that.type,that.name,that.startTime,that.endTime);
       })
       bus.$on('packageTypeId',function(msg){
           that.type = msg;
           that.getLessonPackageData(1,that.gradeId,that.subjectId,that.termId,that.versionId,that.type,that.name,that.startTime,that.endTime);
       })
    },
    updated(){
        this.documentHeight = this.$refs.ImgBoxWidth0[0].clientWidth*1/0.72+'px'
        //console.log('图片宽度',this.$refs.ImgBoxWidth0[0].clientWidth)
    },
    methods:{
        //获取备课包列表
        getLessonPackageData(pageNo,gradeId,subjectId,termId,versionId,type,name,startTime,endTime){
            const that = this;
            const result = [];
            const url =  '/axt-resources/package_prepare/pageCourse';
            var params = {
                name: name,
                gradeId: gradeId,
                subjectId: subjectId,
                catalogId: termId,
                versionId: versionId,
                websiteId:this.websiteId,
                type: type,
                publishStatus: 1,
                startTime : startTime,
                endTime : endTime,
                pageNo: pageNo,
                pageSize: 15,
                status: 1,
                source: 1,
                "orderBys": [{
                      "direction": "desc",
                      "field": "update_time"
                }]

            };
            //console.log(params,"222222")
            api.postFormAPI(url,params).then(res => {

                if (res.data.success) {
                  //console.log('qqqq',res.data.data)
                    that.microNum = res.data.data.total;                        //备课包总数量
                    that.pageTotal = res.data.data.total;                   //分页总数
                    const packageList = res.data.data.rows;
                    for(let i = 0 ; i < packageList.length; i++){
                      if(packageList[i].versionName == undefined) packageList[i].versionName = '';
                      if(packageList[i].gradeName == undefined) packageList[i].gradeName = '';
                      if(packageList[i].subjectName == undefined) packageList[i].subjectName = '';
                     // console.log(packageList[i].versionName)
                    }
                    for(let i=0;i < packageList.length;i+=5){
                        result.push(packageList.slice(i,i+5));
                    }
                    that.packageList = result;
                    //console.log(that.packageList)
                }else{
                    // that.$Message.error(res.data.message);
                    that.microNum = 0
                    that.pageTotal = 0
                }
            })
        },
        //翻页
        changePage(page){
            const that = this;
            this.getLessonPackageData(page,that.gradeId,that.subjectId,that.termId,that.versionId,that.type,that.name);
        },
        //点击查看详情
        toPackageDetail(packageId){
          this.$emit('isShow',false);
          this.$nextTick(() => {
              bus.$emit('packageId',packageId)
          })

        }
    }
}
</script>
<style lang="" scoped>
    .packageContent{
        margin-top: 23px;
        min-height: 500px;
    }
    .packageNum{
        width:100%;
        font-size: 14px;
        color: #9A9A9A;
        line-height: 56px;
        text-align: left;
        margin-top: 10px;
    }
    .packageCar{
        width:19%;
        background: white;
        box-shadow: 0px 0px 15px 8px rgba(203, 209, 219, 0.32);
        border-radius: 10px;
        margin-right: 1.25%;
        cursor: pointer;
        position: relative;
    }
    .packageCar:nth-of-type(5n+5){
      margin-right: 0;
    }
    .packageCar:hover{
        
        /* margin-top:-10px; */
        animation-name:ImgPackage;
        animation-duration:.3s;
        animation-fill-mode: forwards;
    }
    @keyframes ImgPackage{
    	from {top:0px;}
    	to {top:-10px;}
    }
    @-webkit-keyframes ImgPackage /* Safari 和 Chrome */{
    	from {top:0px;}
    	to {top:-10px;}
    }
    .pacageTop{
        /* height:210px; */
        display:flex;
        flex-direction: row;
    }
    .packageTL{
        flex:1;
        display: table-cell;
        line-height: 1.6;
    }
    .packageTL img{
        width:80%;
        height: 80%;
        border-radius: 8px;
        margin: auto;
        display: inline-block;
        vertical-align: middle;
    }
    .packageTR{
        flex:1;
        text-align: left;
        padding-top: 17px;
        display: flex;
        flex-flow: column;
    }
    .packageTitle{
        font-size: 16px;
        font-weight: 500;
        color: #34495E;
        line-height: 1.6;
        height: 50px;
        margin: 6px 0 30px;
    }
    .packageCom{
        font-size: 14px;
        color: #999999;
        line-height: 1.6;
    }
    .packageBottom{
        background: #3683FF;
        font-size: 14px;
        color:#ffffff;
        text-align: center;
        line-height: 35px;
        border-radius: 0px 0px 10px 10px;
    }
    @media screen and (min-width: 1440px ) {
           .packageCom {
            line-height: 1.6;
          }
        }
    @media screen and (min-width: 1600px ) {
       .packageCom {
        line-height: 2;
      }
    }
    /* @media screen and (min-width: 1024px) {
        .pacageTop {
           height:180px;
        }
        .packageTL img{
            height: 120px;
        }
        .packageBottom{
            line-height: 20px;
        }
         .packageCom{
            line-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .packageTitle{
            line-height: 50px;
        }
        .packageTL{
            line-height: 180px;
        }
    }
    @media screen and (min-width: 1100px) {
        .pacageTop {
           height:180px;
        }
        .packageTL img{
            height: 120px;
        }
        .packageBottom{
            line-height: 20px;
        }
         .packageCom{
            line-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .packageTitle{
            line-height: 50px;
        }
        .packageTL{
            line-height: 180px;
        }
    }

    @media screen and (min-width: 1280px) {
         .microImgBox {
           height:200px;
        }
    }
    @media screen and (min-width: 1366px) {
        .microImgBox {
           height:200px;
        }
    }
    @media screen and (min-width: 1440px) {
        .microImgBox {
           height:200px;
        }
    }
    @media screen and (min-width: 1680px) {
        .microImgBox {
           height:210px;
        }
    }
    @media screen and (min-width: 1920px) {
        .microImgBox {
           height:220px;
        }
    } */
</style>



// WEBPACK FOOTER //
// src/components/PackageList/PackageList.vue